import React, { useEffect, useRef, useState } from 'react';

export const DeferredRender = ({
  children,
  fallback = null,
  rootMargin = '0px 0px 520px 0px',
  minHeight = 0,
  className
}) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      return undefined;
    }

    const node = containerRef.current;

    if (!node || typeof window === 'undefined' || typeof window.IntersectionObserver !== 'function') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new window.IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [isVisible, rootMargin]);

  return (
    <div
      className={className}
      ref={containerRef}
      style={minHeight ? { minHeight } : undefined}
    >
      {isVisible ? children : fallback}
    </div>
  );
};
